import { Fragment, useMemo } from 'react';
import VBDropdown from '@vb-js-commons/new/vbDropdown';
import VBSearchInput from '@vb-js-commons/new/vbSearchInput';
import XIcon from '../../../../assets/icons/X.svg';
import LeftIcon from '../../../../assets/icons/icon-left.svg';
import { Button, Icon, Sheet, Text, Tooltip, Popover, TwModal } from "@ui-component-library";
import { cn } from '@utils/cn';
import TreebulaIcon from '@assets/treebula/icon.svg';

// Modals
export const ForestandCreateModal = ({ forestandCreateModal, setForestandCreateModal, setFileError, fileError, searchProps, searchTimeout, setSearchTimeout, generateForestandSBP }) => {
    return (
        <TwModal isOpen={forestandCreateModal?.show} className="bg-neutral-cloud-200 p-2">
            <TwModal.Header>
                <div className="flex justify-between items-start">
                    <h2 className="text-[25px] leading-[112%] tracking-[-0.5px] mb-0">Importera en skogsbruksplan (.xml)</h2>
                    <button type="button" className="ml-4 text-2xl leading-none" onClick={() => setForestandCreateModal({ ...forestandCreateModal, show: false })} aria-label="Close">&times;</button>
                </div>
            </TwModal.Header>
            <TwModal.Content>
                <div className="mb-6">
                    <label className="block font-medium" for="forestandPropFile">Välj fil att ladda upp</label>
                    <div className="flex flex-col items-start">
                        <input type="file" id="forestandPropFile" className="absolute opacity-0" style={{ width: "20px" }} onChange={(e) => {
                            if (e.target.files[0]) {
                                const file = e.target.files[0]
                                const fileType = file.name.split('.').pop().toLowerCase();
                                if (fileType !== 'xml') {
                                    setFileError("Endast forestan XML-filer är tillåtna");
                                    setForestandCreateModal({ ...forestandCreateModal, file: null });
                                }
                                else {
                                    const reader = new FileReader()

                                    reader.onload = (event) => {
                                        const parser = new DOMParser();
                                        const xmlDoc = parser.parseFromString(event.target.result, "text/xml");
                                        if (!xmlDoc.getElementsByTagNameNS("*", "ForestandData").length) {
                                            setFileError("Ogiltig XML-fil. Endast ForestandData XML är tillåten.")
                                            setForestandCreateModal({ ...forestandCreateModal, file: null });
                                        }
                                        else {
                                            setFileError("")
                                            setForestandCreateModal({ ...forestandCreateModal, file: file })
                                        }

                                    };
                                    reader.readAsText(file)
                                }
                            }
                        }} />
                        {forestandCreateModal.file && <a className='mt-2 bg-supp-forest-green-300 p-2 mr-2 white rounded-full text-[13px] leading-[120%] tracking-[-0.26px] inline-block'>{forestandCreateModal?.file?.name}
                            <XIcon width='16px' height='16px' className='ml-2 white-filter' role='button'
                                onClick={() => {
                                    setForestandCreateModal({ ...forestandCreateModal, file: null });
                                }}
                            />
                        </a>}
                        <label className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border text-white bg-[#023436] border-[#023436] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#144143] enabled:hover:border-[#144143] enabled:active:bg-[#012526] enabled:active:border-[#012526] mt-4" htmlFor="forestandPropFile" role='button'> <LeftIcon widt="18px" height="18px" className={`mr-2`} />Välj filer</label>
                    </div>
                    {fileError && <p className="text-danger text-[13px] leading-[120%] tracking-[-0.26px] mt-1">{fileError}</p>}
                </div>
                <div>
                    <p className='text-[16px] leading-[125%] tracking-[-0.32px] mb-1'>Hitta ansluten fastighet hos Lantmäteriet:</p>
                    <p className='text-[16px] leading-[125%] tracking-[-0.32px]'>Vald fastighet: <b>{forestandCreateModal?.lm_info?.beteckning ? forestandCreateModal.lm_info.beteckning : ''}</b></p>
                    <VBSearchInput
                        id='propSearchInput'
                        initial={forestandCreateModal.searchText}
                        placeholder='Sök eller eg: Sevedstorp 1:8'
                        onChange={async (val) => {
                            setForestandCreateModal({ ...forestandCreateModal, searchText: val })

                            if (searchTimeout) {
                                clearTimeout(searchTimeout)
                            }
                            const timeout = setTimeout(async () => {
                                const searchResult = await searchProps(val)
                                setForestandCreateModal({ ...forestandCreateModal, searchResult: searchResult.data })
                            }, 400)

                            setSearchTimeout(timeout)
                        }}
                        searchResult={
                            forestandCreateModal?.searchText !== '' &&
                                forestandCreateModal?.searchResult && forestandCreateModal.searchResult.length > 0 ?
                                forestandCreateModal?.searchResult?.map((prop, index) => <p key={index} className="option w-full pl-2" onClick={() => setForestandCreateModal({ ...forestandCreateModal, lm_info: prop })}>{prop.beteckning}</p>) :
                                <p>Inga träffar på den sökningen.</p>
                        } />
                </div>
            </TwModal.Content>
            <TwModal.Footer>
                <div className="flex justify-between">
                    <button type="button" className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border text-[#2a2e33] [background-clip:padding-box] bg-transparent border-transparent disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[rgba(5,56,56,0.1)] enabled:hover:border-[rgba(5,56,56,0.1)] enabled:active:bg-[rgba(3,51,53,0.26)] enabled:active:border-[rgba(3,51,53,0.26)]" onClick={() => { setForestandCreateModal({ ...forestandCreateModal, show: false }); setFileError("") }}>Avbryt</button>
                    <button type="button" className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border bg-[#dfff5d] border-[#dfff5d] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#cbe855] enabled:hover:border-[#cbe855] enabled:active:bg-[#9eb542] enabled:active:border-[#9eb542]" onClick={() => {
                        if (!forestandCreateModal.file) {
                            setFileError("Vänligen välj en fil att ladda upp.");
                        } else {
                            setFileError("")
                            generateForestandSBP({ file: forestandCreateModal.file, lm_info: forestandCreateModal.lm_info });
                            setForestandCreateModal({ ...forestandCreateModal, show: false });
                        }
                    }}>Spara</button>
                </div>
            </TwModal.Footer>
        </TwModal>
    )
}

export const CreateADModal = ({createAdModal, setCreateAdModal, handleCreateAd}) => {
        return (
            <TwModal isOpen={createAdModal.show} className="bg-neutral-cloud neutral-charcoal p-2">
                <TwModal.Header>
                    <div className="flex justify-between items-start">
                        <h2 className="mb-0 n-h5">{createAdModal.title ? createAdModal.title : 'Är det dags att avverka eller gallra?'}</h2>
                        <button type="button" className="ml-4 text-2xl leading-none" onClick={() => setCreateAdModal({ show: false })} aria-label="Close">&times;</button>
                    </div>
                </TwModal.Header>
                <TwModal.Content className="py-0">
                    {createAdModal.message ? createAdModal.message :
                        <>
                            <p className='text-[.8rem] leading-[.9rem]'>Att sälja virke genom Treebula är <b>alltid kostnadsfritt</b> och ger dig i snitt <b>23% högre virkespriser.</b> Vi kopplar samman dig med alla potentiella virkesköpare för att säkerställa högst värde för ditt virke</p>
                            <p className='text-[.8rem] leading-[.9rem]'>Du <b>binder dig inte till något,</b> du får anbud av intresserade köpare och bestämmer själv om du vill sälja. Om du inte är nöjd tackar du enkelt nej.</p>
                            <p className='text-[.8rem] leading-[.9rem]'>Välj vilken åtgärd det är det dags för nedan. Vi återkommer till dig inom kort med vilken ytterligare information vi behöver</p>

                            <VBDropdown
                                inputStyle={{ minHeight: 0 }}
                                label={<label>Vilken åtgärd är det dags för?</label>}
                                onChange={(val) => setCreateAdModal({ ...createAdModal, type: val.value })}
                                error={createAdModal.error}
                                options={[{ label: "Slutavverkning", value: "slutavverkning" }, { label: "Gallring", value: "gallring" }, { label: "Plockhuggning", value: "plockhuggning" }, { label: "Biobränsle eller GROT", value: "grot" }, { label: "Sälja leveransvirke", value: "leveransvirke" }]}
                                inputMode='none' />
                        </>}
                </TwModal.Content>
                <TwModal.Footer>
                    <div className={cn('flex', createAdModal.done ? 'justify-end' : 'justify-between')}>
                        {!createAdModal.done && <button type="button" className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border text-white bg-[#023436] border-[#023436] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#144143] enabled:hover:border-[#144143] enabled:active:bg-[#012526] enabled:active:border-[#012526]" onClick={() => setCreateAdModal({ show: false })}>Stäng</button>}
                        <button type="button" className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border bg-[#dfff5d] border-[#dfff5d] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#cbe855] enabled:hover:border-[#cbe855] enabled:active:bg-[#9eb542] enabled:active:border-[#9eb542]" onClick={() => !createAdModal.loading && handleCreateAd()}>{createAdModal.loading ? <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin align-middle" /> : createAdModal.done ? 'Stäng' : 'Gå vidare'}</button>
                    </div>
                </TwModal.Footer>
            </TwModal>
        )
    }

export const OffcanvasSheetWrapper = ({ openSheet, setOpenSheet, menuItems, menuFooter }) => {
        return (
            <Sheet isOpen={openSheet} onClose={() => setOpenSheet(false)} side="left" className="max-w-[236px]">
                <Sheet.Header className="justify-between items-center">
                    <a href="/" className="flex items-center justify-center h-[32px] w-[32px]">
                        <TreebulaIcon width="24px" />
                    </a>
                    <Button
                        onClick={() => setOpenSheet(false)}
                        size="icon"
                        variant="tertiary"
                        aria-label="Sidebar"
                    >
                        <Icon name="CrossSimple" size="large" />
                    </Button>
                </Sheet.Header>
                <Sheet.Content>{menuItems()}</Sheet.Content>
                <Sheet.Footer>{menuFooter()}</Sheet.Footer>
            </Sheet>
        )
    }

// MENU BUTTON
export const MenuButton = ({ label, iconName, isActive, onClick, isMinimized, iconSize = "large", type = "sidebar", href, preventMouseDownFocus = false }) => {
    const className = cn('flex items-center px-3 py-2-5 rounded-lg cursor-pointer transition-colors h-10 hover:bg-cloud-200 no-underline text-inherit', isActive ? 'bg-cloud-200' : '', isMinimized && type === "sidebar" ? 'justify-center' : '');
  
    const handleMouseDown = (e) => {
        if (!preventMouseDownFocus) {
            return;
        }
        e.preventDefault();
    };
    const content = (
        <>
            {isMinimized && type === "sidebar" ? (
                <Tooltip content={label} side="right">
                    <Icon name={iconName} size={iconSize} className={cn(isActive && "fill-[#1A1A1A]", label === "Logga ut" ? "rotate-90" : "")} />
                </Tooltip>
            ) : (
                <Icon name={iconName} size={iconSize} className={cn(isActive && "fill-[#1A1A1A]", label === "Logga ut" ? "rotate-90" : "")} />
            )}
            {(!isMinimized || type === "dialog") && (
                <span className="ml-2">
                    <Text variant={`${isActive ? "text-sm/leading-none/medium" : "text-sm/leading-none/normal"}`} className={cn(!isActive && 'text-charcoal-1000')}>{label}</Text>
                </span>
            )}
        </>
    );
    if (href) {
        return (
            <a href={href} className={className}>
                {content}
            </a>
        );
    }

    return (
        <div
            className={className}
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && onClick?.()}
            onMouseDown={handleMouseDown}
        >
            {content}
        </div>
    );

};

const ProfilePopoverContent = ({ initial, profileLinks, view, userData }) => {
    return (
        <div className="flex flex-col overflow-hidden">
            <div className="flex flex-col pb-2">
                <div className="flex gap-2 overflow-hidden">
                    <Text variant="text-xs/leading-normal/medium" className="shrink-0 rounded-lg bg-cloud-200 p-2 w-9 h-9 text-center flex items-center justify-center">
                        {initial}
                    </Text>
                    <div className="flex flex-col overflow-hidden min-w-0">
                        <Text variant="text-sm/leading-normal/semibold" className="truncate max-w-[156px]">
                            {userData.name}
                        </Text>
                        <Text variant="text-xs/leading-normal/normal" className="truncate color-charcoal-400 max-w-[156px]">
                            {userData.email}
                        </Text>
                    </div>
                </div>
                <div className="h-px w-full bg-[#E6E6E6] mt-2" />
            </div>
            <div className="flex flex-col gap-1.5">
                {profileLinks.map((item) => (
                    <Fragment key={item.id}>
                        {item.id === 'logga-ut' && <div className="h-px w-full bg-[#E6E6E6]" />}
                        <MenuButton
                            label={item.label}
                            iconName={item.icon}
                            iconSize="large"
                            isActive={view?.comp === item.id}
                            type="dialog"
                            onClick={item.onClick}
                            isMinimized={false}
                        />
                    </Fragment>
                ))}
            </div>

        </div>
    );
}


export const ProfilePopover = ({
    initial,
    profileLinks,
    view,
    userData,
    open,
    onOpenChange,
    children,
    side = 'bottom',
    align = 'end',
    contentClassName = '',
}) => {
    const content = useMemo(
        () => <ProfilePopoverContent initial={initial} profileLinks={profileLinks} view={view} userData={userData} />,
        [initial, profileLinks, view, userData]
    );
    return (
    <Popover
        content={content}
        side={side}
        align={align}
        open={open}
        onOpenChange={onOpenChange}
        contentClassName={contentClassName}
    >
        {children}
    </Popover>
)};
